import {
    Activity,
    BrainCircuit,
    ClipboardCheck,
    HeartPulse,
    Library,
    Tags,
} from "lucide-preact";

type TabId =
    | "health"
    | "processing"
    | "review"
    | "library"
    | "tags"
    | "ai-analysis";

type ManageTabBarProps = {
    activeTab: TabId;
    onTabChange: (tab: TabId) => void;
    processingCount?: number;
    reviewCount?: number;
    aiAnalysisCount?: number;
};

const TABS: { id: TabId; label: string; icon: typeof Activity; }[] = [
    {
        id: "health",
        label: "Health",
        icon: HeartPulse,
    },
    {
        id: "processing",
        label: "Processing",
        icon: Activity,
    },
    {
        id: "review",
        label: "Review",
        icon: ClipboardCheck,
    },
    {
        id: "library",
        label: "Library",
        icon: Library,
    },
    {
        id: "tags",
        label: "Tags",
        icon: Tags,
    },
    {
        id: "ai-analysis",
        label: "AI Analysis",
        icon: BrainCircuit,
    },
];

export const ManageTabBar = ({
    activeTab,
    onTabChange,
    processingCount,
    reviewCount,
    aiAnalysisCount,
}: ManageTabBarProps) => {
    const getCount = (tabId: TabId): number | undefined => {
        if (tabId === "processing") return processingCount;
        if (tabId === "review") return reviewCount;
        if (tabId === "ai-analysis") return aiAnalysisCount;
        return undefined;
    };

    return (
        <div className="border-b border-border bg-bg-secondary">
            <div className="max-w-6xl mx-auto px-4 flex gap-1">
                {TABS.map((tab) => {
                    const Icon = tab.icon;
                    const count = getCount(tab.id);
                    const isActive = activeTab === tab.id;

                    return (
                        <button
                            type="button"
                            key={tab.id}
                            onClick={() => onTabChange(tab.id)}
                            className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                                isActive
                                    ? "border-accent text-accent"
                                    : "border-transparent text-text-secondary hover:text-text-primary hover:border-border"
                            }`}
                        >
                            <Icon size={16} />
                            {tab.label}
                            {count !== undefined && count > 0 && (
                                <span
                                    className={`px-1.5 py-0.5 text-xs rounded-full ${
                                        isActive
                                            ? "bg-accent/20 text-accent"
                                            : "bg-bg-tertiary text-text-secondary"
                                    }`}
                                >
                                    {count}
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
